import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql, compose } from "react-apollo";
import { FormattedMessage, injectIntl } from "react-intl";

// Redux
import { connect } from "react-redux";

// Style
import { Grid, Row, Col } from "react-bootstrap";
import cx from "classnames";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "./Dashboard.css";
import bt from "../../components/commonStyle.css";

// Component
import UnreadMessages from "./UnreadMessages";
import DashboardMenu from "./DashboardMenu";
import DashBoardSideMenu from "./DashBoardSideMenu";

// Graphql
import UnreadThreadsQuery from "./getUnreadThreads.graphql";
import GetHostDashboardStats from "./getHostDashboardStats.graphql";

// Locale
import messages from "../../locale/messages";

//Images
import WavingHand from "/public/SiteIcons/wavingHand.png";
import BookingInformation from "./BookingInformation";
import DashboardUpcomingReservations from "./DashboardUpcomingReservations";
import Loader from "../Loader/Loader";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      listId: null,
      startDate: null,
      endDate: null,
      orderBy: null,
      searchKey: "",
      userType: "host",
      dateFilter: "",
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, // Get browser timezone
    };
    this.setStateVariable = this.setStateVariable.bind(this);
  }

  static propTypes = {
    formatMessage: PropTypes.any,
    account: PropTypes.shape({
      userId: PropTypes.string.isRequired,
      picture: PropTypes.string,
      firstName: PropTypes.string,
    }).isRequired,
    allUnreadThreads: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      getDashboardUnreadThreads: PropTypes.array,
    }),
    dashboardStats: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      getHostDashboardStats: PropTypes.object,
    }),
    siteName: PropTypes.string.isRequired,
  };

  static defaultProps = {
    allUnreadThreads: {
      loading: true,
      getDashboardUnreadThreads: [],
    },
    dashboardStats: {
      loading: true,
      getHostDashboardStats: null,
    },
    account: {
      userId: null,
      picture: null,
    },
  };

  setStateVariable(variables) {
    const { onChangeListing } = this.props;
    this.setState(variables);
    // onChangeListing(variables)
  }

  render() {
    const {
      account: { userId, picture, firstName },
      siteName,
    } = this.props;
    const {
      allUnreadThreads: { loading, getDashboardUnreadThreads },
      dashboardStats: { loading: statsLoading, getHostDashboardStats },
    } = this.props;

    const { formatMessage } = this.props.intl;

    const { type } = this.props;
    const {
      searchKey,
      currentPage,
      listId,
      startDate,
      endDate,
      orderBy,
      dateFilter,
      userType,
    } = this.state;

    let newMessages = 0;
    if (!loading && getDashboardUnreadThreads) {
      newMessages = getDashboardUnreadThreads.length;
    }

    // Dashboard stats data
    const { hasListing } = getHostDashboardStats || {};

    const messageCount =
      formatMessage(messages.messages) +
      ` (${newMessages} ` +
      formatMessage(messages.messagesNew) +
      ")";

    return (
      <>
        <Grid fluid className={cx(s.pageContainer, "ViewProfile")}>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className={"dashBoardGrid"}>
                <div>
                  <DashBoardSideMenu />
                </div>
                <div>
                  <div className={cx("commonListingBg", "dashboard")}>
                    <h3 className={bt.listingTitleText}>
                      <span className={cx(s.waveHandImage, "waveHandImageRTL")}>
                        <img src={WavingHand} />
                      </span>
                      <span className={s.waveHandImageSection}>
                        {formatMessage(messages.sayHelloTo)}{" "}
                        {firstName && <> {firstName}</>}
                      </span>
                    </h3>
                    <p className={cx(s.grayTextColor)}>
                      <span>
                        {formatMessage(messages.sayHelloTo) + " " + firstName}
                        {"!,"}
                      </span>{" "}
                      <FormattedMessage {...messages.dashBoardInfo} />
                    </p>
                    <p className={cx(s.grayTextColor, s.noMargin)}>
                      <FormattedMessage {...messages.dashBoardInfo1} />
                    </p>
                  </div>
                  <div>
                    {hasListing ? (
                      <>
                        <BookingInformation
                          dashboardCount={getHostDashboardStats}
                        />
                        <DashboardUpcomingReservations
                          searchKey={searchKey}
                          currentPage={currentPage}
                          listId={listId}
                          startDate={startDate}
                          endDate={endDate}
                          orderBy={orderBy}
                          dateFilter={dateFilter || type}
                          userType={userType}
                          setStateVariable={this.setStateVariable}
                        />
                      </>
                    ) : hasListing === false ? (
                      <>
                        <DashboardMenu />
                        <h4 className={s.messageCountText}>{messageCount}</h4>
                        <UnreadMessages
                          userId={userId}
                          loading={loading}
                          getUnreadThreads={getDashboardUnreadThreads}
                        />
                      </>
                    ) : (
                      <Loader type={"text"} />
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </>
    );
  }
}

const mapState = (state) => ({
  account: state.account.data,
  siteName: state.siteSettings.data.siteName,
});

const mapDispatch = {};

export default compose(
  injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch),
  graphql(UnreadThreadsQuery, {
    name: "allUnreadThreads",
    options: {
      ssr: false,
      pollInterval: 5000,
      fetchPolicy: "network-only",
    },
  }),
  graphql(GetHostDashboardStats, {
    name: "dashboardStats",
    options: (props) => ({
      ssr: false,
      variables: {
        hostId: props.account.userId,
        timeZone:
          props.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      pollInterval: 5000,
      fetchPolicy: "network-only",
    }),
  })
)(Dashboard);
